// @flow

import React from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

type Props = {
  children?: any,
};

const Wrapper = styled.li`
  margin-bottom: 10px;

  &:last-child {
    margin-right: 0;
  }

  ${breakpoint('tablet')`
    margin-right: 20px;
  `};
`;

const Filter = ({ children }: Props) => <Wrapper>{children}</Wrapper>;

export default Filter;
